// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Jx0U","alert":"SettungsInbox_alert__1O5ak"};